import {
  Badge,
  Box,
  Flex,
  Grid,
  Image,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/core";
import { useStoreActions, useStoreState } from "easy-peasy";

import React from "react";
import Card from "../../../../Components/Card";
import NavBar from "../../../../Components/NavBar";
import Eligibility from "../EditProfile/Eligibility";
import OtherDetails from "../EditProfile/OtherDetails";
import PersonalInfo from "../EditProfile/PersonalInfo";
import ProfessionalDetails from "../EditProfile/ProfessionalDetails";
import Resume from "../EditProfile/Resume";
import Skills from "../EditProfile/Skills";
import ProfileCard from "./ProfileCard";
import TabBar from "./TabBar";
import Account from "../../../../static/assets/icons/Profile/Account.png";
import Notification from "../../../../static/assets/icons/Profile/Notification.png";
import { userData } from "../../../../Data/Profile/index";

import ProfilePageContainer from "./ProfilePageContainer";
import QuickLinks from "./QuickLinks";

function ViewProfile() {
  const index = useStoreState((state) => state.profile.index);
  const { setIndex } = useStoreActions((actions) => ({
    setIndex: actions.setIndex,
  }));
  return (
    <Box>
      <NavBar />
      <Tabs tabIndex={index} onChange={(index) => setIndex(index)}>
        <Flex
          justifyContent="space-evenly"
          marginTop="65.6px"
          align="center"
          backgroundColor="#293c43"
        >
          <TabBar />
          <Flex>
            <Image size="20px" mr="5" src={Account} />
            <Box>
              <Image size="20px" src={Notification} />
              <Badge rounded="full" variantColor="green">
                12
              </Badge>
            </Box>
          </Flex>
        </Flex>
        <TabPanels>
          <TabPanel>
            <ProfileCard profile={userData} />
            <Grid mt="5" mr="3" gap="1em" templateColumns="0.8fr 2fr">
              <QuickLinks />
              <ProfilePageContainer />
            </Grid>
          </TabPanel>
          <TabPanel>
            <Card>
              <Resume />
            </Card>
          </TabPanel>
          <TabPanel>
            <Card>
              <PersonalInfo />
            </Card>
          </TabPanel>
          <TabPanel>
            <Card>
              <Skills />
            </Card>
          </TabPanel>
          <TabPanel>
            <Card>
              <ProfessionalDetails />
            </Card>
          </TabPanel>
          <TabPanel>
            <Card>
              <Eligibility />
            </Card>
          </TabPanel>
          <TabPanel>
            <Card>
              <OtherDetails />
            </Card>
          </TabPanel>
          <TabPanel>8</TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}

export default ViewProfile;
